import axiosClient from "api/axiosInstance";

export const getBalancePlans = async (
  startDate: string,
  endDate: string,
): Promise<any> => {
  const client = axiosClient();
  const response = await client.get(
    `/balance-plans?start_date=${startDate}&end_date=${endDate}`,
  );
  return response.data;
};

export const exportBalancePlan = async (
  balancePlanId: number,
): Promise<any> => {
  const client = axiosClient();
  const response = await client.get(
    `/balance-plans/${balancePlanId}/export`,
    { responseType: "blob" },
  );
  return response.data;
};

export const sendBalancePlan = async (balancePlanId: number): Promise<any> => {
  const client = axiosClient();
  const response = await client.post(`/balance-plans/${balancePlanId}/send`);
  return response.data;
};
